(() => {
  'use strict';

  const configElement = document.getElementById('cds22-three-pack-config');

  if (!configElement) return;

  let config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('[CDS22 three-pack] Invalid configuration.', error);
    return;
  }

  if (!config.enabled || !config.targets || !config.targets[config.mode]) return;

  const target = config.targets[config.mode];
  const fixedQuantity = Number(config.quantity) || 3;
  const presentation = config.presentation || {};
  const targetVariantId = String(target.variantId);
  const targetPortalProductId = String(target.productId);
  const isSubscriptionPortal = window.location.pathname.includes('/a/subscriptions/manage/');
  const subscriptionLineKeys = new Set();
  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = `${cartRoot}cart.js`;
  const cartUpdateUrl = `${cartRoot}cart/update.js`;

  let cartCorrectionInFlight = false;
  let scanQueued = false;

  const isTargetSubscriptionItem = (item) =>
    String(item.variant_id || item.id) === targetVariantId && Boolean(item.selling_plan_allocation);

  const productFormIsTarget = (form) => {
    if (!form || !form.matches('form[action*="/cart/add"]')) return false;

    if (form.dataset.productHandle === target.handle) return true;

    const variantInput = form.querySelector('[name="id"]');
    const isTargetPage = window.location.pathname.includes(`/products/${target.handle}`);

    return isTargetPage && variantInput && String(variantInput.value) === targetVariantId;
  };

  const subscriptionIsSelected = (form) => {
    const sellingPlan = form.querySelector('[name="selling_plan"]');

    if (sellingPlan && String(sellingPlan.value).trim() !== '') return true;

    const subscriptionRadio = form.querySelector('.sls-option[data-type="subscription"]');
    const subscriptionOption = form.querySelector(
      '.sls-option-container[data-selling-plan-group].sls-active'
    );

    return Boolean((subscriptionRadio && subscriptionRadio.checked) || subscriptionOption);
  };

  const updateSubscriptionPresentation = (form) => {
    if (!productFormIsTarget(form)) return;

    const radio = form.querySelector('.sls-option[data-type="subscription"]');
    const option = radio && radio.closest('.sls-option-container');

    if (!option) return;

    option.dataset.cds22ThreePackOption = 'true';

    const title = String(presentation.title || 'Subscribe — 3-Pack Plan');
    const totalPrice = String(presentation.totalPrice || '£59.22');
    const details = String(
      presentation.details || `${fixedQuantity} packs per subscription delivery`
    );
    const label = option.querySelector('.sls-selling-plan-group-name');
    const price = option.querySelector('.sls-selling-plan-group-price');
    const labelContainer = option.querySelector('.sls-label-container');

    if (label) {
      let customTitle = label.querySelector('.cds22-three-pack-option-title');

      if (!customTitle) {
        customTitle = document.createElement('span');
        customTitle.className = 'cds22-three-pack-option-title';

        Array.from(label.childNodes).forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
        });

        label.insertBefore(customTitle, label.firstChild);
      }

      if (customTitle.textContent !== title) customTitle.textContent = title;
    }

    if (radio.getAttribute('aria-label') !== title) radio.setAttribute('aria-label', title);

    const radioControl = radio.closest('[role="radio"]');
    if (radioControl && radioControl.getAttribute('aria-label') !== title) {
      radioControl.setAttribute('aria-label', title);
    }

    if (price && price.textContent.trim() !== totalPrice) price.textContent = totalPrice;

    if (labelContainer) {
      let summary = option.querySelector('.cds22-three-pack-subscription-summary');

      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'cds22-three-pack-subscription-summary';
        labelContainer.appendChild(summary);
      }

      if (summary.textContent !== details) summary.textContent = details;
    }
  };

  const updateThemePricePresentation = (form, subscriptionSelected) => {
    if (!productFormIsTarget(form)) return;

    const productScope = form.closest('.product-content') || document;
    const displayedPrice = subscriptionSelected
      ? String(presentation.totalPrice || '£59.22')
      : String(presentation.oneTimePrice || '£22.95');
    const displayedDiscount = subscriptionSelected
      ? String(presentation.subscriptionDiscount || '14%')
      : String(presentation.oneTimeDiscount || '4%');

    productScope
      .querySelectorAll('[data-product-price], .product__price > .money')
      .forEach((price) => {
        if (price.textContent.trim() !== displayedPrice) price.textContent = displayedPrice;
      });

    productScope.querySelectorAll('[data-price-off-amount]').forEach((discount) => {
      if (discount.textContent.trim() !== displayedDiscount) {
        discount.textContent = displayedDiscount;
      }
    });
  };

  const lockProductQuantity = (form) => {
    if (!productFormIsTarget(form)) return;

    updateSubscriptionPresentation(form);
    const subscriptionSelected = subscriptionIsSelected(form);
    updateThemePricePresentation(form, subscriptionSelected);

    const input = form.querySelector('input[name="quantity"]');
    const wrapper = input && input.closest('[data-quantity-selector]');

    if (!input || !wrapper) return;

    if (!subscriptionSelected) {
      if (wrapper.dataset.cds22ThreePackLocked !== 'true') return;

      const originalValue = input.dataset.cds22OriginalValue || '1';
      const originalMin = input.dataset.cds22OriginalMin;
      const originalMax = input.dataset.cds22OriginalMax;

      input.readOnly = false;
      input.removeAttribute('aria-readonly');

      if (originalMin) input.setAttribute('min', originalMin);
      else input.removeAttribute('min');

      if (originalMax) input.setAttribute('max', originalMax);
      else input.removeAttribute('max');

      wrapper.querySelectorAll('.quantity__button').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });

      delete wrapper.dataset.cds22ThreePackLocked;
      input.value = originalValue;
      input.setAttribute('value', originalValue);
      input.removeAttribute('data-cds22-original-value');
      input.removeAttribute('data-cds22-original-min');
      input.removeAttribute('data-cds22-original-max');
      return;
    }

    if (wrapper.dataset.cds22ThreePackLocked !== 'true') {
      input.dataset.cds22OriginalValue = input.value || '1';
      input.dataset.cds22OriginalMin = input.getAttribute('min') || '';
      input.dataset.cds22OriginalMax = input.getAttribute('max') || '';
    }

    wrapper.dataset.cds22ThreePackLocked = 'true';
    input.readOnly = true;
    input.setAttribute('aria-readonly', 'true');
    input.setAttribute('min', String(fixedQuantity));
    input.setAttribute('max', String(fixedQuantity));

    wrapper.querySelectorAll('.quantity__button').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });

    input.value = String(fixedQuantity);
    input.setAttribute('value', String(fixedQuantity));
  };

  const cartRowIsTarget = (row) => {
    if (!row) return false;

    const input = row.querySelector('[data-update-cart]');
    const lineKey = input && input.getAttribute('data-update-cart');

    if (lineKey && subscriptionLineKeys.has(lineKey)) return true;

    const productLink = row.querySelector(
      `a[href*="variant=${targetVariantId}"][href*="selling_plan="]`
    );

    return Boolean(productLink);
  };

  const lockCartRow = (row) => {
    if (!cartRowIsTarget(row)) return;

    const input = row.querySelector('[data-update-cart]');
    const wrapper = input && input.closest('[data-quantity-selector]');

    if (!input || !wrapper) return;

    wrapper.dataset.cds22ThreePackLocked = 'true';
    input.value = String(fixedQuantity);
    input.readOnly = true;
    input.setAttribute('aria-readonly', 'true');
    input.setAttribute('min', String(fixedQuantity));
    input.setAttribute('max', String(fixedQuantity));

    wrapper.querySelectorAll('.quantity__button').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });
  };

  const portalMatchesConfiguredSubscription = () => {
    const configuredId = String(target.portalSubscriptionId || '').trim();

    if (!configuredId) return true;

    const subscriptionId = document.querySelector('.seal-sub-id');
    const displayedId = subscriptionId && subscriptionId.textContent.replace(/\D/g, '');

    return displayedId === configuredId;
  };

  const normalizePortalProductId = (productId) => String(productId || '').replace(/^s/, '');

  const portalRowProductId = (row) => {
    if (!row) return '';

    const savedProductId = row.getAttribute('data-item-product-id');
    const newProductId = row.querySelector(
      'input[name^="new_items"][name$="[product_id]"]'
    );

    return normalizePortalProductId(savedProductId || (newProductId && newProductId.value));
  };

  const portalRowIsTargetProduct = (row) =>
    Boolean(
      row &&
        portalMatchesConfiguredSubscription() &&
        portalRowProductId(row) === targetPortalProductId
    );

  const portalRowIsNewItem = (row) =>
    Boolean(row && row.querySelector('input[name^="new_items"][name$="[product_id]"]'));

  const portalRowQuantity = (row) => {
    if (!row) return NaN;

    const input = row.querySelector('[data-seal-quantity]');
    const displayedQuantity = row.querySelector('.seal-product-quantity');
    const value = input ? input.value : displayedQuantity && displayedQuantity.textContent;
    const normalizedValue = String(value || '').trim();

    return normalizedValue ? Number(normalizedValue) : NaN;
  };

  const portalRowShouldBeLocked = (row) => {
    if (!portalRowIsTargetProduct(row)) return false;

    const savedEligibility = row.dataset.cds22ThreePackPortalEligibility;

    if (savedEligibility) return savedEligibility === 'locked';

    if (portalRowIsNewItem(row)) {
      row.dataset.cds22ThreePackPortalEligibility = 'locked';
      return true;
    }

    const existingQuantity = portalRowQuantity(row);

    if (!Number.isFinite(existingQuantity)) return false;

    const shouldLock = existingQuantity === fixedQuantity;
    row.dataset.cds22ThreePackPortalEligibility = shouldLock ? 'locked' : 'grandfathered';

    return shouldLock;
  };

  const lockPortalRow = (row) => {
    if (!portalRowShouldBeLocked(row)) return;

    row.dataset.cds22ThreePackPortalLocked = 'true';

    const input = row.querySelector('[data-seal-quantity]');
    const displayedQuantity = row.querySelector('.seal-product-quantity');
    const productDetails =
      row.querySelector('.seal-flex-col') || row.querySelector('.seal-twoThirds');

    if (input) {
      input.value = String(fixedQuantity);
      input.setAttribute('value', String(fixedQuantity));
      input.setAttribute('min', String(fixedQuantity));
      input.setAttribute('max', String(fixedQuantity));
      input.readOnly = true;
      input.setAttribute('aria-readonly', 'true');
      input.setAttribute('title', `Quantity is fixed at ${fixedQuantity} for this subscription plan.`);
    }

    if (
      displayedQuantity &&
      displayedQuantity.textContent.trim() !== String(fixedQuantity)
    ) {
      displayedQuantity.textContent = String(fixedQuantity);
    }

    if (productDetails && !row.querySelector('.cds22-three-pack-portal-note')) {
      const note = document.createElement('div');
      note.className = 'cds22-three-pack-portal-note';
      note.setAttribute('role', 'note');
      note.textContent = `Fixed ${fixedQuantity}-pack subscription`;
      productDetails.appendChild(note);
    }
  };

  const lockPortalRows = () => {
    if (!isSubscriptionPortal) return;

    document
      .querySelectorAll('#seal-subscription-items-list [data-item-id]')
      .forEach((row) => lockPortalRow(row));
  };

  const scanPage = () => {
    if (isSubscriptionPortal) {
      lockPortalRows();
      return;
    }

    document
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach((form) => lockProductQuantity(form));

    document.querySelectorAll('[data-cart-item]').forEach((row) => lockCartRow(row));
  };

  const queueScan = () => {
    if (scanQueued) return;

    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      scanPage();
    });
  };

  const syncProductForm = (form) => {
    if (!productFormIsTarget(form)) return;

    window.requestAnimationFrame(() => lockProductQuantity(form));
    window.setTimeout(() => lockProductQuantity(form), 0);
    window.setTimeout(() => lockProductQuantity(form), 150);
  };

  const publishCart = (cart) => {
    document.dispatchEvent(
      new CustomEvent('theme:cart:change', {
        bubbles: true,
        detail: { cart }
      })
    );
    document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
  };

  const enforceCart = async (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;

    const targetLines = cart.items.filter(isTargetSubscriptionItem);

    subscriptionLineKeys.clear();
    targetLines.forEach((item) => subscriptionLineKeys.add(item.key));
    queueScan();

    if (!targetLines.length || cartCorrectionInFlight) return;

    const totalQuantity = targetLines.reduce((total, item) => total + Number(item.quantity), 0);
    const cartIsValid = targetLines.length === 1 && totalQuantity === fixedQuantity;

    if (cartIsValid) return;

    const updates = {};
    targetLines.forEach((item, index) => {
      updates[item.key] = index === 0 ? fixedQuantity : 0;
    });

    cartCorrectionInFlight = true;

    try {
      const response = await fetch(cartUpdateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) throw new Error(`Cart correction failed with status ${response.status}.`);

      const correctedCart = await response.json();
      subscriptionLineKeys.clear();
      correctedCart.items.filter(isTargetSubscriptionItem).forEach((item) => {
        subscriptionLineKeys.add(item.key);
      });
      publishCart(correctedCart);
      queueScan();
    } catch (error) {
      console.warn('[CDS22 three-pack] Could not correct the cart.', error);
    } finally {
      cartCorrectionInFlight = false;
    }
  };

  const loadAndEnforceCart = async () => {
    if (cartCorrectionInFlight) return;

    try {
      const response = await fetch(cartUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) return;
      await enforceCart(await response.json());
    } catch (error) {
      console.warn('[CDS22 three-pack] Could not read the cart.', error);
    }
  };

  const targetCartRowFromEvent = (event) => {
    const row = event.target.closest && event.target.closest('[data-cart-item]');
    return cartRowIsTarget(row) ? row : null;
  };

  const targetPortalRowFromEvent = (event) => {
    const row = event.target.closest && event.target.closest('[data-item-id]');
    return portalRowShouldBeLocked(row) ? row : null;
  };

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('#seal-subscription-items-list-container [data-action="save"]')) {
        lockPortalRows();
      }

      const cartRow = targetCartRowFromEvent(event);

      if (
        cartRow &&
        event.target.closest('[data-increase-quantity], [data-decrease-quantity]')
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        lockCartRow(cartRow);
        return;
      }

      const productForm = event.target.closest && event.target.closest('form[action*="/cart/add"]');
      if (productForm) syncProductForm(productForm);
    },
    true
  );

  ['input', 'change'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        const portalRow = targetPortalRowFromEvent(event);

        if (portalRow && event.target.matches('[data-seal-quantity]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          lockPortalRow(portalRow);
          return;
        }

        const cartRow = targetCartRowFromEvent(event);

        if (cartRow && event.target.matches('[data-update-cart]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          lockCartRow(cartRow);
          return;
        }

        const form = event.target.closest && event.target.closest('form[action*="/cart/add"]');
        if (form) syncProductForm(form);
      },
      true
    );
  });

  ['beforeinput', 'keydown', 'paste'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        const portalRow = targetPortalRowFromEvent(event);

        if (portalRow && event.target.matches('[data-seal-quantity]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          lockPortalRow(portalRow);
        }
      },
      true
    );
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (productFormIsTarget(form) && subscriptionIsSelected(form)) {
        lockProductQuantity(form);
      }

      if (form.matches && form.matches('form[action="/cart"]')) {
        form.querySelectorAll('[data-cart-item]').forEach((row) => lockCartRow(row));
      }
    },
    true
  );

  document.addEventListener('formdata', (event) => {
    if (productFormIsTarget(event.target) && subscriptionIsSelected(event.target)) {
      event.formData.set('quantity', String(fixedQuantity));
    }

    const portalItemsForm =
      event.target.closest &&
      (event.target.closest('#seal-subscription-items-list-container') ||
        event.target.querySelector('#seal-subscription-items-list-container'));

    if (portalItemsForm && portalMatchesConfiguredSubscription()) {
      document
        .querySelectorAll('#seal-subscription-items-list [data-item-id]')
        .forEach((row) => {
          if (!portalRowShouldBeLocked(row)) return;

          const input = row.querySelector('[data-seal-quantity]');
          if (input && input.name) event.formData.set(input.name, String(fixedQuantity));
        });
    }
  });

  document.addEventListener('theme:cart:change', (event) => {
    enforceCart(event.detail && event.detail.cart);
  });

  document.addEventListener(
    'seal:subscription_item_added',
    (event) => {
      if (!portalMatchesConfiguredSubscription()) return;

      const items = event.detail && event.detail.items;

      if (Array.isArray(items)) {
        items.forEach((item) => {
          if (normalizePortalProductId(item.product_id) === targetPortalProductId) {
            item.quantity = fixedQuantity;
          }
        });
      }

      lockPortalRows();
    },
    true
  );

  document.addEventListener('theme:drawer:open', (event) => {
    if (event.target && event.target.matches('[data-drawer="drawer-cart"]')) {
      loadAndEnforceCart();
    }
  });

  const observerRoot = isSubscriptionPortal
    ? document.querySelector('.seal-subscription-page') || document.documentElement
    : document.documentElement;

  new MutationObserver(queueScan).observe(observerRoot, {
    childList: true,
    subtree: true
  });

  scanPage();

  if (window.location.pathname === '/cart') loadAndEnforceCart();
})();
